import { DATA_STATUS, NOT_FOUND_ERROR_404 } from '@/constants';
import * as dataSelectors from '@/data/data-selectors';
import { strComplaintsAvailable as strComplaintsAvailableSelector } from '@/data/data-selectors';
import { useSelector } from 'react-redux';

export function useComplaints() {
  const complaints = useSelector(dataSelectors.propertyComplaintsData);
  const strComplaintsAvailable = useSelector(strComplaintsAvailableSelector);
  const loading = !complaints || complaints === DATA_STATUS.inProgress;
  const notFound = complaints?.Code === NOT_FOUND_ERROR_404;
  return {
    complaints,
    loading,
    notFound,
    isEnabled: strComplaintsAvailable,
  };
}
